// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export const FEATUREFLAG_DISABLE_AUTHENTICATION = "DISABLE_AUTHENTICATION";
